import { render, staticRenderFns } from "./SuperAdminStepRootView.vue?vue&type=template&id=499205b0"
import script from "./SuperAdminStepRootView.vue?vue&type=script&lang=js"
export * from "./SuperAdminStepRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports